import React from 'react';
export function ResultPortrait() {
  return <section className="bg-warm-light py-16 md:py-20 px-4" data-id="element-225">
      <div className="max-w-3xl mx-auto text-center" data-id="element-226">
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm mb-3" data-id="element-227">
          Beautiful portraits your dog deserves
        </p>

        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-228">
          <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=900&h=700&fit=crop&crop=faces" alt="Stunning close-up portrait of a beautiful dog looking directly at the camera with warm soft light and expressive eyes" className="w-full h-auto object-cover" data-id="element-229" />
        </div>

        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-230">
          Learn how to create cleaner, warmer, more expressive dog portraits —{' '}
          <span className="font-semibold text-warm-hero" data-id="element-231">
            without making photography feel complicated.
          </span>
        </p>
      </div>
    </section>;
}